import { IUser } from './user'

export abstract class ISessionUpdateService {
  abstract updateCurrentUser: (user: IUser) => void
}
